import * as React from "react";
function GoogleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1422_1145)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.843 6.548a6.521 6.521 0 00-4.604-1.8c-3.13 0-5.79 2.113-6.737 4.957a7.188 7.188 0 000 4.594h.004c.953 2.84 3.607 4.952 6.738 4.952 1.616 0 3.003-.413 4.078-1.143v-.003a5.554 5.554 0 002.399-3.647h-6.482v-4.62h11.319c.141.802.207 1.622.207 2.438 0 3.65-1.304 6.735-3.574 8.825l.003.002C18.205 22.937 15.476 24 12.239 24a12.002 12.002 0 01-10.723-6.61 12.01 12.01 0 010-10.776A11.998 11.998 0 0112.239 0a11.533 11.533 0 018.03 3.122l-3.426 3.426z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1422_1145"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h24v24H0z"
  }))));
}
const ForwardRef = React.forwardRef(GoogleIcon);
export default ForwardRef;